import React from 'react';

import { PricesFixed, PricePerDay,PricesWeekly,PricesHourly } from 'components';

import { useStyles } from 'components/prices-create/styles';

const RentalPricesCreate = ({ 
  selectedTabIndex, 
  onSubmit,
  setSubmitButton,
  isUpdate,
}) => {
  const classes = useStyles();

  const PRICES = {
    fixedPrices: 0,
    dailyPrices: 1,
    weeklyPrices: 2,
    hourlyPrices:3
  };

  return (
    <div className={classes.wrapper}>
      {selectedTabIndex === PRICES.fixedPrices && (
        <PricesFixed onSubmit={values => onSubmit(values, 'pricesFixedForm')}
         setSubmitButton={setSubmitButton}
         isUpdate={isUpdate}
        />
      )}
      {selectedTabIndex === PRICES.dailyPrices && (
        <PricePerDay
          onSubmit={values => onSubmit(values, 'pricesDailyForm')}
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      )}

      {selectedTabIndex === PRICES.weeklyPrices && (
        <PricesWeekly
          onSubmit={values => onSubmit(values, 'pricesWeeklyForm')}
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      )}

      {selectedTabIndex === PRICES.hourlyPrices && (
        <PricesHourly
          onSubmit={values => onSubmit(values, 'pricesHourlyForm')}
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      )}
    </div>
  );
};

export default RentalPricesCreate;
